<template>
    <div class="components-info-panel">
        <p class="title">基本信息</p>
        <el-row class="paddingB40 paddingL20">
            <el-col :span="8">
                <span class="gray">用户名称:</span>
                {{ user.empName || user.name }}
            </el-col>
            <el-col :span="8">
                <span class="gray">用户账号:</span>
                {{ user.loginName || user.username }}
            </el-col>
            <el-col :span="8">
                <span class="gray">入职时间:</span>
                {{ user.entryDate }}
            </el-col>
            <el-col :span="8">
                <span class="gray">用工关系:</span>
                {{ user.emprelatStatus }}
            </el-col>
            <el-col :span="8">
                <span class="gray">最高学历:</span>
                {{ user.maxDegree }}
            </el-col>
            <el-col :span="8">
                <span class="gray">最高学位:</span>
                {{ user.maxEducBackground }}
            </el-col>
            <el-col :span="8">
                <span class="gray">政治面貌:</span>
                {{ user.politicsStatus }}
            </el-col>
        </el-row>
        <p class="title">联系方式</p>
        <el-row>
            <el-col v-if="user.telPhone || user.phone" :span="8">
                <i class="icon iconfont icon-dianhua- color1"></i>
                <span class="gray">手机号码:</span>
                {{ user.telPhone || user.phone }}
            </el-col>
            <el-col v-if="user.officePhone" :span="8">
                <i class="icon color2 iconfont icon-dianhua-1"></i>
                <span class="gray">办公电话:</span>
                {{ user.officePhone }}
            </el-col>
            <el-col v-if="user.email" :span="8">
                <i class="icon color2 iconfont icon-youxiang-1"></i>
                <span class="gray">邮箱地址:</span>
                {{ user.email }}
            </el-col>
            <el-col v-if="user.wechatAccount" :span="8">
                <i class="icon color1 iconfont icon-z-weixin-"></i>
                <span class="gray">微信账号:</span>
                {{ user.wechatAccount }}
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: {
        username: {
            type: String,
            require: true,
        },
    },
    computed: {
        ...mapState({
            userData: (state) => state.user.userData,
            oauth: (state) => state.user.oauth,
        }),
    },
    data() {
        return {
            get_data_api: "/user/personalCenter/basicInfo",
            // get_data_api: '/user/detail',
            // get_data_api: '/uc/user/detail',
            user: {},
        };
    },
    created() {
        if (this.oauth.userFrom === 1) {
            this.user = { ...this.userData };
        } else {
            this.getData();
        }
    },
    methods: {
        getData() {
            this.$axios.get(this.get_data_api, { username: this.username }).then((res) => {
                this.user = res.body || {};
                this.$store.commit("UPDATE_USER_LEVEL", this.user.subLevel);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.components-info-panel {
    line-height: 2.6;
    .icon {
        display: inline-block;
        margin-right: 6px;
        line-height: 1;
    }
}
.title {
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    padding-bottom: 20px;
}
.color1 {
    color: #5ac66a;
}
.color2 {
    color: #3296fa;
}
</style>
